import React from 'react';
import Library from './Library';

const LibraryView: React.FC = () => {
  return <Library />;
};

export default LibraryView;